<div *ngIf="!state.loaded" class="lazy-bg"></div>

<figure *ngIf="state.visible" [class]="class">
	<img [hidden]="!state.loaded" (load)="onLoad()" [src]="src" [alt]="alt" [class]="class" />
</figure>
